import { useEffect, useState } from "react";
import accountsApi from "../../services/accountsCommonService";

export default function useAccountMeta() {
  const [meta, setMeta] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    let live = true;
    accountsApi.meta()
      .then((result) => { if (live) setMeta(result?.data || null); })
      .catch((err) => { if (live) setError(err.message); });
    return () => { live = false; };
  }, []);

  const labelOf = (list, value) => (meta?.[list] || []).find((item) => item.value === value)?.label || value || "";
  return { meta, error, labelOf };
}
